import { render, staticRenderFns } from "./userRegulations.vue?vue&type=template&id=3972a52a"
import script from "./userRegulations.vue?vue&type=script&lang=js"
export * from "./userRegulations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports